export default __webpack_public_path__ + "static/media/border-thickness.e57e55e3.svg";